import React from 'react';
import type { IMessage } from '@/types/admin/messages';
import { FileBubble } from './FileBubble';

type Props = {
  message: IMessage;
  authUserId?: number;
};

export const AttachmentMessageDesktop: React.FC<Props> = ({ message, authUserId }) => {
  if (!message.files || message.files.length === 0) return null;
  return (
    <>
      {message.files.map((file, idx) => (
        <FileBubble
          key={`${message.id}:${idx}`}
          file={file}
          isAdmin={message.isAdmin}
          authUserId={authUserId}
        />
      ))}
    </>
  );
};

export default AttachmentMessageDesktop;


